<template>
    <article class="slds-card" style="height:100%">
        <demo-boost-dialog @on-demo-boost-completion="onCompleteDemoBoost"  v-if="showDemoBoost == true"/>
        <div class="slds-card__header slds-grid">
            <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__figure">
                <span class="slds-icon_container slds-icon-standard-task"><svg class="slds-icon slds-icon_medium" aria-hidden="true">
                    <use xlink:href="libs/vendors/salesforce-lightning-design-system-2.6.2//assets/icons/standard-sprite/svg/symbols.svg#task"></use>
                </svg></span>
            </div>
            <div class="slds-media__body">
                <h2 class="slds-card__header-title slds-m-top_none" style="text-align:left">
                <a href="#" class="slds-card__header-link slds-truncate" title="Demo Boost">
                    <span style="font-size:14px;line-height:24px;color:#080707">Demo Boost</span>
                </a>
                </h2>
            </div>
            </header>
        </div>
        <div class="slds-card__body slds-card__body_inner slds-m-left_large" style="text-align:left;">
            <p style="font-size:14px;line-height:21px;color:#404040">One stop solution for automated scripts</p>
            <a target="_blank" class="slds-button slds-button_brand" v-on:click="onClickButton" style="width:fit-content;margin-top:20px;text-align:left">Run Demo Boost</a>
        </div>
        <toast v-bind:toasts="toasts"></toast>

    </article>
</template>
<script>
    import { mixpanelMixin } from '../mixpanelMixin';
    import DemoBoostDialog from './DemoBoostDialog.vue'
    import Toast from './Toast.vue';
    export default{
        name: 'CardView',
        mixins: [ mixpanelMixin ],
        data() {
            return{
                showDemoBoost : false,
                showToast : false,
                toasts : []
            }
        },
        components: {
            DemoBoostDialog,Toast
        },
        methods:{
            onClickCloseToast(){
                this.showToast = false;  
            },
            onClickButton(){ 
                this.showDemoBoost = true;
            },
            onCompleteDemoBoost(status){
                this.showDemoBoost = false;
                this.createToast('success','Demo Boost executed successfully. We’ll email you in a few minutes when it’s all done.');
            },
            createToast(type, message) {
                this.toasts.push({ type, message });
            },
        }
    }
</script>
